<div
    class="relative grow overflow-y-auto"
    [ngClass]="{ 'blur-[2px] pointer-events-none [&_*]:select-none': loading() }"
>
    @if (loading()) {
        <div
            class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50"
        >
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    @if (location.error()) {
        <div class="p-4 text-red-500">Lokacija nije pronađena.</div>
    }

    @if (loaded()) {
        <div class="flex flex-col gap-4 bg-valamargray border-2 static p-4">
            <button class="flex valben-button text-lg ml-auto" (click)="save()">Spremi</button>

            <valben-dictionary-input
                [formField]="locationForm.names"
                title="Naziv"
            ></valben-dictionary-input>

            <valben-boolean-input
                [formField]="locationForm.isActive"
                title="Aktivan"
            ></valben-boolean-input>

            <valben-boolean-input
                [formField]="locationForm.isDraft"
                title="Skica"
            ></valben-boolean-input>

            <valben-location-input
                [formField]="locationForm.geolocation"
                title="Lokacija"
            ></valben-location-input>

            <div class="flex gap-4 justify-end items-center select-none">
                <button class="valben-button text-lg" (click)="back()">Natrag</button>
                <button class="valben-button text-lg" (click)="showDeleteModal()">Obriši</button>
                <button class="valben-button text-lg" (click)="save()">Spremi</button>
            </div>
        </div>
    }
</div>
